import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of, Subject } from 'rxjs';
import { catchError, delay, tap } from 'rxjs/operators';

import { User } from '../models/user.model';
import { BaseService } from './base.service';
import { Router } from '@angular/router';
import { ServerRoute } from '../models/server-route.model';

@Injectable()
export class UserService {
  private userSource = new Subject();
  userSource$ = this.userSource.asObservable();
  constructor(
    private httpClient: HttpClient,
    private baseService: BaseService,
    private router: Router
  ) {}

  isLoggedIn: boolean;
  redirectUrl: string;
  user: User;
  menuRoutes: ServerRoute[];
  logout(): void {
    const url = `${this.baseService.hostDomain}/api/logout`;
    this.httpClient
      .post(url, null)
      .pipe(
        catchError(err => {
          this.baseService.handleError(
            err,
            'Obteniendo información de usuario.'
          );
          return [];
        })
      )
      .subscribe(() => {
        this.isLoggedIn = false;
        this.user = null;
        this.refreshStatus();
        this.router.navigate(['/salir']);
      });
  }

  getUser(): Observable<User> {
    const url = `${this.baseService.hostDomain}/api/user`;
    return this.httpClient.get<User>(url).pipe(
      catchError(err => {
        this.baseService.handleError(err, 'Obteniendo información de usuario.');
        return [];
      })
    );
  }
  refreshStatus() {
    if (this.user) {
      this.menuRoutes = this.user.routes
        .filter(route => route.url.indexOf(':') === -1)
        .filter(route => route.url.indexOf('nuevo') === -1)
        .filter(route => route.url.indexOf('.*') === -1);
    } else {
      this.menuRoutes = null;
    }
    this.userSource.next();
  }
}
